// File: src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, useParams } from "react-router-dom";

export  const ProtectedRoute = ({ children }) => {
  const storedToken = localStorage.getItem("token"); // Token stored locally
  const { username } = useParams(); // Get token from URL

  if (!storedToken || storedToken !== username) {
    // Remove invalid token and redirect to login
    localStorage.removeItem("token");
    return <Navigate to="/adminlogin" />;
  }

  return children;
};

// default ProtectedRoute;
